import * as pc from "playcanvas";
import { UI } from "./UI";
import gsap from "gsap";
import { MaterialManager } from "./MaterialManager";
import { IRWN } from "./IRWN";
import { PlantScene } from "./PlantScene";
import { AssetLoader } from "./AssetLoader";

export const ClockScene = {
  Params: {
    vignetteSoften: 0.2,
    vignetteWipe: 0.0,

    // plant positions
    p1: { x: 170, y: 744, angle: 0.532, revealed: false },
    p2: { x: 472.94, y: 603.54, angle: 0.613, revealed: false },
    p3: { x: 672.88, y: 382.54, angle: 0.673, revealed: false },
    p4: { x: 730, y: 92.37, angle: 0.722, revealed: false },
    p5: { x: 709.34, y: -235.59, angle: 0.805, revealed: false },
    p6: { x: 569.88, y: -521.31, angle: 0.868, revealed: false },
    p7: { x: 323.97, y: -695.52, angle: 0.939, revealed: false },
    p8: { x: 21.85, y: -745.38, angle: 0.036, revealed: false }, // starts here
    p9: { x: -333.97, y: -705.84, angle: 0.07, revealed: false },
    p10: { x: -617.73, y: -525.2, angle: 0.146, revealed: false },
    p11: { x: -716.73, y: -267.46, angle: 0.205, revealed: false },
    p12: { x: -699.19, y: 335.99, angle: 0.342, revealed: false },
    p13: { x: -226.3, y: 700.87, angle: 0.461, revealed: false },
  },

  init: function (playcanvasApp) {
    this.playcanvasApp = playcanvasApp;
    this.date = new Date();
    this.plantImages = [];
    this.setupComplete = false;
  },
  //------------------------------------> SETUP
  setup: function () {
    MaterialManager.setUniforms("loaderCurtain", {
      col: [IRWN.palette.white.r, IRWN.palette.white.g, IRWN.palette.white.b],
      soften: ClockScene.Params.vignetteSoften,
      opacity: 1,
      wipe: 0,
      vertWipe: 0,
    });
    if (!this.setupComplete) {
      this.e_loaderCurtain = UI.addShaderElement(
        "e_loaderCurtain",
        UI.e_screen,
        1024,
        1024,
        "loaderCurtain"
      );
      this.img_loaderCurtain = this.e_loaderCurtain.element;
      this.img_loaderCurtain.anchor = new pc.Vec4(0, 0, 1, 1);
      this.setupComplete = true;
    }
    this.e_loaderCurtain.enabled = false;
  },
  flush: function () {},
  loadScene: function (sceneID = undefined) {
    // reset the loader shader values
    MaterialManager.setUniforms("loaderCurtain", {
      col: [IRWN.palette.white.r, IRWN.palette.white.g, IRWN.palette.white.b],
      soften: ClockScene.Params.vignetteSoften,
      opacity: 1,
      wipe: 0,
      vertWipe: 0,
    });
    this.targetPlantID = sceneID;
    this.loadComplete = false;
    this.resetLoaderImages();
    this.loaderProgress(0);

    // hide the PlantScene UI if it's on screen
    PlantScene.hideUI();
    this.reveal();
  },
  update: function (dt) {},
  resetLoaderImages: function () {
    for (let i = 1; i <= 13; i++) {
      ClockScene.Params["p" + i].revealed = false;
    }
  },
  loaderProgress: function (p) {
    this.Params.loaderProgress = p;
    this.updatePath();
    if (!this.loadComplete) {
      for (let i = 1; i <= 13; i++) {
        const imgConfig = ClockScene.Params["p" + i];

        if (!imgConfig.revealed && p + 0.035 > imgConfig.angle) {
          gsap.killTweensOf("#loader_plant" + i, "opacity");
          gsap.to("#loader_plant_" + i, {
            opacity: 1,
            duration: 1,
            ease: "strong.in",
          });
          imgConfig.revealed = true;
        }
      }
    }
  },
  reveal: function () {
    this.revealParams = {
      clockOpacity: 0,
      innerRadius: 1,
      vignetteWipe: 0,
      textOpacity: 0,
      vertWipe: 1,
    };
    // disabling this in order to fix the loader flash when clicking the Enter button
    // this.e_loaderCurtain.enabled = true;
    // reveal loader vertically
    gsap.to(this.revealParams, {
      vertWipe: 0,
      delay: 0,
      duration: 4,
      ease: "expo.inOut",
      callbackScope: this,
      onUpdate: this.onPositionReveal,
      onComplete: this.onLoaderRevealComplete,
    });

    // reveal loader
    gsap.to("#loader_ring_bg", {
      opacity: 1,
      delay: 1.5,
      duration: 3,
      ease: "strong.in",
    });
    gsap.to("#loader_ring_fg", {
      opacity: 1,
      delay: 1.5,
      duration: 2,
      ease: "strong.in",
    });

    // welcome message and time
    gsap.killTweensOf(".clock_message", "opacity");
    gsap.to(".clock_message", {
      opacity: 1,
      delay: 3,
      duration: 2,
      ease: "strong.in",
    });
  },

  hide: function () {
    this.loadComplete = true;
    gsap.killTweensOf(this.revealParams, "vignetteWipe");
    gsap.to(this.revealParams, {
      vignetteWipe: 1,
      delay: 0.2,
      duration: 5,
      ease: "expo.in",
      callbackScope: this,
      onUpdate: this.onVignetteWipeUpdate,
      onComplete: this.onHideComplete,
    });

    gsap.killTweensOf(".clock_message", "opacity");
    gsap.killTweensOf(".clock_time", "opacity");
    gsap.killTweensOf(".clock_suffix", "opacity");
    gsap.to(".clock_message", { opacity: 0, duration: 2 });

    gsap.to("#loader_ring_bg", { opacity: 0, duration: 3, ease: "none" });
    gsap.to("#loader_ring_fg", { opacity: 0, duration: 3, ease: "none" });
    for (let i = 1; i <= 13; i++) {
      gsap.killTweensOf("#loader_plant" + i, "opacity");
      gsap.to("#loader_plant_" + i, { opacity: 0, duration: 3 });
    }
  },
  onPositionReveal: function () {
    this.e_loaderCurtain.enabled = true;
    MaterialManager.setUniform(
      "loaderCurtain",
      "vertWipe",
      this.revealParams.vertWipe
    );
  },
  onLoaderRevealUpdate: function () {
    MaterialManager.setUniforms("arc1", {
      innerRadius: this.revealParams.innerRadius,
    });
    MaterialManager.setUniforms("arc2", {
      innerRadius: this.revealParams.innerRadius,
    });
  },
  onVignetteWipeUpdate: function () {
    MaterialManager.setUniform(
      "loaderCurtain",
      "wipe",
      this.revealParams.vignetteWipe
    );
  },
  onLoaderRevealComplete: function () {
    AssetLoader.flushAssets();
    if (this.targetPlantID != null) {
      IRWN.loadScene(this.targetPlantID);
    } else {
      IRWN.loadCurrentScene();
    }
    this.loadingPlant = true;
  },
  onHideComplete: async function () {
    this.loaderProgress(0);
    this.e_loaderCurtain.enabled = false;
  },

  resizeHandler: function (w, h, pxRatio) {},
  updatePath: function () {
    document.getElementById("loader_ring_fg").style.clipPath = this.getPath(
      this.Params.loaderProgress
    );
  },
  getPath: function (progress) {
    const PI = Math.PI;
    const PI_05 = PI * 0.5;
    const PI_2 = PI * 2;
    const pre = "polygon(";
    let args = "";
    args += "50% 50%,"; // middle
    args += "50% 100%,"; // bottom

    function polar(scalar) {
      const input = PI_2 * progress * scalar + PI_05;
      const percentX = 50 + Math.cos(input) * 50;
      const percentY = 50 + Math.sin(input) * 50;
      return percentX + "% " + percentY + "%,";
    }
    for (let i = 0; i <= 4; i++) {
      args += polar(i * 0.25);
    }
    const post = ")";
    return pre + args.slice(0, -1) + post;
  },
};
